import type { PageActionMaybe } from 'autogen/swagger/all';
import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const PlusOfferNudgeActivatedQuickViewAtom = mediatorAtom<{
    isOpen: boolean;
    pageAction?: PageActionMaybe;
}>({
    isOpen: false
});

export default function usePlusOfferNudgeActivatedQuickView() {
    return useMediatorState(PlusOfferNudgeActivatedQuickViewAtom);
}
